import { useMutation, useQueryClient } from '@tanstack/react-query';
import { License, ManagedAccount } from '@webdev/user-management';
import { useAlerts } from '../../feedback';
import { licenseAssignationKey } from './licenseAssignationKey';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const useSetManagedLicensesToUser = (userId: ManagedAccount['id']) => {
  const client = useUserManagementClientContext();
  const queryClient = useQueryClient();
  const { showError } = useAlerts();

  const { mutate, isLoading } = useMutation({
    mutationFn: (licenses: Array<License['id']>) =>
      client.setManagedLicensesByUsers({ [userId]: licenses }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [licenseAssignationKey] });
    },
    onError: (_e, licences) =>
      licences.length > 1
        ? showError(`The licenses could not be added.`)
        : showError(`The license could not be added.`),
  });

  return { setManagedLicenses: mutate, isUpdating: isLoading };
};
